<div class="lidl-lib-products-fe-price">
    <!-- <label>CHF</label>
    <span>{{price}}</span> -->
</div>
